module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27630",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4190",
      "atom": "static-1.4677",
      "conversations-async-data": "static-2.7262",
      "conversations-error-reporting": "static-1.8479",
      "conversations-infrastructure": "static-1.8501",
      "conversations-internal-pub-sub": "static-1.15562",
      "conversations-internal-schema": "static-1.12214",
      "conversations-message-history": "static-1.11320",
      "conversations-test-sdk": "static-1.9997",
      "conversations-visitor-experience-components": "static-1.20993",
      "head-dlb": "static-1.4465",
      "hs-promise-utils": "static-1.5089",
      "hs-test-utils": "static-1.7494",
      "hubspot-dlb": "static-2.1744",
      "HubStyleTokens": "static-2.11018",
      "I18n": "static-7.1499",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2515",
      "jasmine-runner": "static-1.5976",
      "quartz": "static-1.6362",
      "react-dlb": "static-1.65",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.3955",
      "StyleGuideUI": "static-3.479",
      "transmute": "static-2.77",
      "urlinator": "static-1.4128",
      "usage-tracker": "static-1.6933",
      "usage-tracker-core": "static-1.6783",
      "usage-tracker-public": "static-1.6744",
      "viral-links-lib": "static-1.6515",
      "visitor-ui-component-library": "static-1.5726",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4326",
      "conversations-prop-types": "static-1.6938",
      "conversations-visibility-tools": "static-1.5301",
      "conversations-visitor-message-history": "static-1.19730",
      "cssUtils": "static-1.652",
      "enviro": "static-4.345",
      "flux-actions": "static-1.291",
      "foundations-components": "static-1.7090",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3768",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9233",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.16224",
      "react-utils": "static-2.4952",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7702",
      "signup-constants": "static-1.17905",
      "styled-components": "static-2.64",
      "usage-tracker-multi": "static-1.5347",
      "visitor-ui-component-library-icons": "static-1.5537",
      "hs-promise-rejection-tracking": "static-1.4918",
      "raven-hubspot": "static-1.5693",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3036",
      "moment": "static-3.26",
      "quartz-config": "static-1.140",
      "quartz-core": "static-1.5581",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4385",
      "foundations-theming": "static-1.3924",
      "UIComponents": "static-3.7965",
      "cv-backend-services": "static-1.1397",
      "immutable-less": "static-1.4106",
      "conversations-skeleton-state": "static-1.6852",
      "crm-events-viz-core": "static-1.31803",
      "customer-agent-discovery-components-lib": "static-1.1842",
      "icons": "static-2.599",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4204",
      "tanstack-virtual": "static-1.20",
      "ui-images": "static-2.1012",
      "HeadJS": "static-2.655",
      "framer-motion": "static-1.58",
      "hs-test-utils-bend-plugin": "static-1.2605",
      "msw": "static-1.39",
      "testing-library": "static-1.140",
      "i18n-data": "static-1.212",
      "moment-timezone": "static-5.73",
      "jasmine": "static-4.3823",
      "signup-ui-url-generator": "static-2.7601",
      "HubStyle": "static-2.11326",
      "sassPrefix": "static-1.146",
      "bend-plugin-foundations-components": "static-1.3359",
      "floating-ui": "static-1.46",
      "foundations-theming-specialty": "static-1.1640",
      "hs-story-utils": "static-1.8914",
      "react-virtualized": "static-2.87",
      "tanstack-table": "static-1.23",
      "trellis-assets": "static-1.799",
      "ui-fonts": "static-1.335",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3542",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5350",
      "bender-build-tools": "static-1.2687",
      "dispatcher": "static-1.126",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.734",
      "hub-http-shared-msw-handlers": "static-1.8934",
      "hubspotter-http": "static-1.4246",
      "hubspotter-http-shared-msw-handlers": "static-1.8932",
      "mobile-manifest-mixins": "static-1.428",
      "quartz-auth": "static-1.37",
      "quartz-head": "static-1.27",
      "quartz-i18n": "static-1.37",
      "bend-plugin-foundations-theming": "static-1.2407",
      "foundations-theming-base": "static-1.2909",
      "stylex": "static-1.22",
      "ts-schema": "static-1.3720",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.2061",
      "content-assistance-lib": "static-1.7167",
      "crm-component-utils": "static-1.37918",
      "crm-display-components": "static-1.23668",
      "crm-fe-perf": "static-1.22480",
      "crm-links": "static-1.5741",
      "crm-message-bus": "static-1.41769",
      "crm-search-service-types": "static-1.808",
      "crm-source-interpretation-lib": "static-1.4818",
      "customer-data-communicator": "static-1.44303",
      "customer-data-email": "static-1.17218",
      "customer-data-filters-ui": "static-1.38102",
      "customer-data-objects": "static-1.7204",
      "customer-data-objects-ui-components": "static-1.12543",
      "customer-data-properties": "static-1.50101",
      "customer-data-rte": "static-1.31909",
      "customer-data-ui-utilities": "static-1.9315",
      "data-fetching-client": "static-1.9233",
      "draft-plugins": "static-2.20848",
      "file-manager-components": "static-1.22213",
      "FileManagerCore": "static-1.37712",
      "framework-data-schema-resolvers": "static-1.6464",
      "frontend-preferences-client": "static-1.7514",
      "hubspot-apollo-client": "static-1.4378",
      "hubspot-prosemirror": "static-1.17012",
      "object-comments-thread-lib": "static-1.9551",
      "reference-resolvers-lite": "static-1.7596",
      "ui-addon-upgrades": "static-9.17248",
      "universal-associations-select": "static-1.10529",
      "ai-components-ui-library": "static-1.7725",
      "final-form": "static-1.60",
      "graphql": "static-1.72",
      "superstore": "static-1.4295",
      "ui-addon-video-player": "static-1.8324",
      "ui-coaching-tips": "static-1.27330",
      "card-properties-lib": "static-1.42924",
      "crm-actions": "static-1.5759",
      "crm-cards-data": "static-1.758",
      "crm-cards-sdk": "static-1.42287",
      "customer-data-properties-shared-msw-handlers": "static-1.8261",
      "customer-data-property-utils": "static-1.7542",
      "customer-data-tracking": "static-1.6459",
      "usage-tracker-container": "static-1.6923",
      "framework-data-table": "static-2.10887",
      "location-customization-utils-lib": "static-1.7922",
      "calling-error-reporting": "static-1.30875",
      "calling-internal-common": "static-1.30869",
      "calling-usage-tracker": "static-1.6138",
      "crm_data": "static-4.90518",
      "crm_schema": "static-3.90557",
      "crm-legacy-global-containers": "static-1.23356",
      "customer-data-content": "static-1.26422",
      "draft-content-plugins": "static-1.27271",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23268",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.22968",
      "EmailSignatureEditor": "static-1.23528",
      "FileManagerLib": "static-1.37853",
      "hubspot-prosemirror-plugins": "static-1.17004",
      "integration-settings-components": "static-1.14057",
      "integrations-lib": "static-1.14721",
      "integrations-tracking-lib": "static-1.5176",
      "native-integrations-shared-strings": "static-1.7385",
      "nav-meta": "static-1.28328",
      "onboarding-scopes": "static-1.6044",
      "outreach-assistant-email-generation": "static-1.5352",
      "property-translator": "static-1.4925",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36507",
      "react-colorpicker": "static-2.9772",
      "react-dnd-compat": "static-1.4224",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7756",
      "rich-text-lib": "static-1.19012",
      "sales-email-signature-service-client": "static-1.3436",
      "sequences-lib": "static-1.7356",
      "timezone-utils": "static-2.4740",
      "ui-addon-i18n": "static-1.10589",
      "ui-addon-iframeable": "static-1.8499",
      "ui-business-units-lib": "static-1.8507",
      "ui-gdpr-components": "static-1.9821",
      "ui-shepherd-react": "static-3.9650",
      "user-context": "static-1.4677",
      "whatsapp-sending-lib": "static-1.4349",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4253",
      "salesImages": "static-1.515",
      "customer-data-filters-ui-msw-helpers": "static-1.20536",
      "customer-data-reference-ui-components": "static-1.12622",
      "FormUrlGenerator": "static-2.4219",
      "framework-builder-read-service-client": "static-1.3563",
      "framework-data-schema-quick-fetch": "static-1.6369",
      "inbound-db-meta-service-client": "static-1.3274",
      "inbound-db-properties-service-client": "static-1.3495",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.555",
      "onboarding-tours": "static-1.15978",
      "reporting-datasets-permissions-lib": "static-1.12347",
      "SharedI18nStrings": "static-1.177",
      "ui-addon-teams": "static-1.20935",
      "calling-global-api": "static-1.62979",
      "calling-lifecycle-internal": "static-1.64361",
      "calling-lifecycle-messages": "static-1.56655",
      "commerce-products-lib": "static-1.8156",
      "conditional-properties-service-client": "static-1.3436",
      "external-options-client-types": "static-1.3655",
      "google-libphonenumber": "static-1.27",
      "inbound-db-associations-writes-service-client": "static-1.2762",
      "inbounddb-objects-service-types": "static-1.3754",
      "meetings-icalendar-utils-lib": "static-1.137",
      "multi-currency-client-types": "static-1.3284",
      "object-builder-ui-client": "static-1.47283",
      "pipeline-validation-client-types": "static-1.3496",
      "property-value-citations": "static-1.715",
      "smart-property-lib": "static-1.5068",
      "tiered-pricing": "static-1.499",
      "ui-addon-form-validation": "static-1.10558",
      "fast-json-stable-stringify": "static-1.4",
      "immerable": "static-1.3658",
      "video-components-external": "static-1.9930",
      "video-data-lib": "static-1.33588",
      "audio-components": "static-1.5334",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35364",
      "ui-universal-auth": "static-1.8407",
      "video-components": "static-1.11933",
      "video-embed": "static-1.34422",
      "batch-promise": "static-1.1131",
      "crm-pipelines-api-client-types": "static-1.3645",
      "persist-promise": "static-1.3288",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24097",
      "knowledge-content-types": "static-1.8178",
      "payment-link-components": "static-1.22371",
      "ui-addon-emoji-picker": "static-1.9443",
      "call-summary": "static-1.37670",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9080",
      "feature-store-service-types": "static-1.4134",
      "growth-monetization-service-types": "static-1.4141",
      "merchandise-lib": "static-1.248",
      "purchase-motions-components": "static-1.5090",
      "self-service-api": "static-1.9776",
      "upgrade-management-service-types": "static-1.4125",
      "chatspot-client-types": "static-1.10247",
      "chatspot-core": "static-1.19540",
      "ContentUtils": "static-1.66998",
      "copilot-toolkit": "static-1.9918",
      "growth-onboarding-feedback-components": "static-1.6091",
      "customer-data-sidebar": "static-2.44785",
      "enrichment-properties-lib": "static-1.14186",
      "customer-data-associations": "static-1.6827",
      "deal-intel-decorators": "static-1.580",
      "reporting-data": "static-1.65639",
      "ui-addon-draggable": "static-3.4349",
      "crm-record-cards-service-types": "static-1.3283",
      "crm_universal": "static-1.21376",
      "SalesContentIndexUI": "static-3.8483",
      "signup-ui-lego-core": "static-1.19915",
      "content-embed-lib": "static-1.6942",
      "data-model-builder-lib": "static-1.10865",
      "remote-ui": "static-1.55",
      "ui-components-test-utils": "static-1.5156",
      "ui-extensions-remote-renderer": "static-1.15889",
      "universal-page-editor-lib": "static-1.2586",
      "integrations-error-boundary-lib": "static-1.12136",
      "laboratory-lib": "static-3.6694",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9973",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.44684",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15684",
      "sequences-client-types-lib": "static-1.7213",
      "foundations-components-test-utils": "static-1.4574",
      "magpie-lib": "static-1.5163",
      "navigation-messaging": "static-1.6018",
      "getting-started-shared-tasks": "static-1.17271",
      "getting-started-shared-tasks-store": "static-1.16389",
      "whatsapp-management-lib": "static-1.7508",
      "growth-data-modal": "static-1.4913",
      "growth-onboarding-confetti": "static-1.2609",
      "growth-onboarding-next-action-utils": "static-1.986",
      "navigation-components": "static-1.16691",
      "onboarding-tours-client": "static-1.4192",
      "onboarding-tours-utils": "static-1.44",
      "ui-shepherd-tracker": "static-1.7031",
      "shared-worker-versioning": "static-1.10618",
      "calling-orchestration-shared-library": "static-1.34165",
      "products-iframe-lib": "static-1.6738",
      "products-ui-components-shared-msw-handlers": "static-1.9316",
      "breeze-intelligence-kit": "static-1.5000",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9017",
      "fsm": "static-1.3232",
      "policy-lib": "static-1.6319",
      "react-tinymce": "static-1.54000",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53126",
      "tinymce-plugins": "static-1.56240",
      "tinymce-themes": "static-1.55096",
      "content-media-composition-data-lib": "static-1.10443",
      "content-media-compositions": "static-2.14450",
      "idb-keyval": "static-1.34",
      "magpie-types": "static-1.4623",
      "media-bridge-lib": "static-1.18218",
      "content-icons-ui": "static-1.2067",
      "social-insights-client-types": "static-1.20823",
      "outpost": "static-1.3829",
      "commerce-analytics-service-client": "static-1.3182",
      "ui-addon-opt": "static-4.7996",
      "commerce-tours-lib": "static-1.5363",
      "growth-onboarding-reliability": "static-1.4691",
      "sales-checkout-service-client": "static-1.3194",
      "ai-addon-copilot-preview": "static-1.6937",
      "calling-cross-tab-library": "static-1.18840",
      "calling-lifecycle-usage-tracker": "static-1.7536",
      "wootric-nps": "static-1.6463",
      "nav-client-types": "static-1.1824",
      "purchase-motions-api": "static-1.5092",
      "trials-service-types": "static-1.3542",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4257",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2558",
      "card-payment-highlight-lib": "static-1.35922",
      "card-subscription-highlight-lib": "static-1.38298",
      "commerce-billing-lib": "static-1.17858",
      "commerce-contract-lib": "static-1.10426",
      "crm_components": "static-3.90518",
      "invoices-highlight-card-lib": "static-1.53335",
      "orders-highlight-card-lib": "static-1.20395",
      "products-highlight-card-lib": "static-1.16440",
      "project-storage": "static-1.4228",
      "quotes-highlight-card-lib": "static-1.70420",
      "usage-based-billing-components-lib": "static-1.7433",
      "deal-intel-utils": "static-1.584",
      "reporting-client-types": "static-1.2312",
      "react-flip-move": "static-1.60",
      "FireAlarmUi": "static-1.4139",
      "sales-templates-service-types-lib": "static-1.3808",
      "ui-asset-management-lib": "static-1.10406",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9037",
      "collaboration-sidebar": "static-1.56605",
      "conditional-property-settings-modal": "static-1.11460",
      "data-model-commons-lib": "static-1.11388",
      "feedback-loader": "static-1.28379",
      "html-to-image": "static-1.44",
      "object-definition-builder-lib": "static-1.6594",
      "property-management-iframe": "static-1.11527",
      "reactflow": "static-1.51",
      "simple-data-table": "static-1.1546",
      "used-in-list-lib": "static-1.6449",
      "visual-association": "static-1.5380",
      "highcharts": "static-8.94",
      "reporting-visualizations": "static-1.57716",
      "ui-extensibility-client-types": "static-1.3563",
      "automation-platform-service-types": "static-1.2376",
      "ContentData": "static-1.67073",
      "email-portal-health-service-types": "static-1.572",
      "marketing-email-service-types": "static-1.1685",
      "reactive-lib": "static-1.281",
      "content-whatsapp-service-types": "static-1.118",
      "marketing-platform-lib": "static-1.6318",
      "short-messages-app-service-client": "static-1.3612",
      "ui-tool-access": "static-1.9684",
      "calling-orchestration-schema": "static-1.34390",
      "sales-views-client-types": "static-1.3843",
      "trellis-story-utils": "static-1.4083",
      "storybook-react": "static-1.22",
      "hub-http-contrib": "static-1.2650",
      "interframe": "static-3.4306",
      "tinymce-data": "static-1.39211",
      "ui-addon-sales-email": "static-1.4766",
      "codemirror": "static-5.85",
      "layout-dnd-components": "static-1.11639",
      "layout-dnd-utils": "static-1.10614",
      "react-codemirror": "static-1.10206",
      "ui-brand-identity-lib": "static-1.12943",
      "NamespacedHubStyle": "static-2.8718",
      "hls.js": "static-1.29",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.8650",
      "ai-settings-ui-library": "static-1.7002",
      "chirp-fetch": "static-1.1486",
      "copilot-plugins": "static-1.9891",
      "eligibility-engine-service-types": "static-1.2823",
      "commerce-shared-components-lib": "static-1.17355",
      "commerce-subscription-lib": "static-1.35875",
      "commerce-tools-ui-lib": "static-1.9301",
      "usage-tracker-session-replay": "static-1.4619",
      "utility-belt": "static-1.2046",
      "payments-enrollment-embed-lib": "static-1.21240",
      "quotes-ui-lib": "static-1.79138",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6289",
      "invoices-ui-lib": "static-1.53351",
      "commerce-products-api": "static-1.1553",
      "SafeStorage": "static-1.3899",
      "invoices-iframe-lib": "static-1.55409",
      "quotes-modal-lib": "static-1.101095",
      "reporting-ui-components": "static-2.62913",
      "subscription-experience-data-types": "static-1.14192",
      "association-translator": "static-1.2705",
      "crm-settings-header-lib": "static-1.7796",
      "settings-ui-nav": "static-2.9738",
      "chatspot-widget-iframe": "static-1.19532",
      "collaboration-sidebar-common": "static-1.1401",
      "crm-properties-common-lib": "static-1.5359",
      "ui-addon-draggable-compat": "static-2.3855",
      "property-management-common": "static-1.3814",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14441",
      "advanced-menus-lib": "static-1.11455",
      "ExportDialog": "static-6.9982",
      "ui-memberships-settings-lib": "static-1.32788",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.8939",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.12914",
      "highlight.js": "static-1.69",
      "reporting-action-components": "static-1.40122",
      "ui-addon-react-router-dom": "static-1.9142",
      "growth-onboarding-empty-states": "static-1.5078",
      "InboxConnectUtils": "static-4.13694",
      "payments-post-enroll-local-storage-lib": "static-1.4577",
      "qrcode-generator": "static-1.59",
      "amplitude-session-replay-browser": "static-1.50",
      "marketplace-ui-apps-core": "static-1.16863",
      "stripe-embedded-components": "static-1.6780",
      "products-ui-components": "static-1.38675",
      "totals-ui-components": "static-1.22388",
      "reporting-plugins": "static-1.9609",
      "reporting-reports": "static-1.65319",
      "reporting-snowflake": "static-1.54259",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14440",
      "simple-menus-lib": "static-1.15957",
      "academy-common-lib": "static-1.12374",
      "dashboard-lib": "static-1.79755",
      "share-with-third-party-component-lib": "static-1.8237",
      "developer-experience-shared-components": "static-1.9967",
      "marketplace-ui-client-types": "static-1.15736",
      "marketplace-ui-common": "static-1.18329",
      "ui-addon-integrations-directory-panel": "static-2.7579",
      "stripe-connect-js": "static-1.43",
      "commerce-permissions": "static-1.299",
      "property-description-translator": "static-1.3372",
      "commerce-totals-service-types": "static-1.3401",
      "campaign-roi-lib": "static-1.7635",
      "academy-service-client": "static-1.3245",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3496",
      "oauth-service-types": "static-1.3808",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27630",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4190",
      "atom": "/atom/static-1.4677",
      "conversations-async-data": "/conversations-async-data/static-2.7262",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8479",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8501",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15562",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12214",
      "conversations-message-history": "/conversations-message-history/static-1.11320",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9997",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20993",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-promise-utils": "/hs-promise-utils/static-1.5089",
      "hs-test-utils": "/hs-test-utils/static-1.7494",
      "hubspot-dlb": "/hubspot-dlb/static-2.1744",
      "HubStyleTokens": "/HubStyleTokens/static-2.11018",
      "I18n": "/I18n/static-7.1499",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2515",
      "jasmine-runner": "/jasmine-runner/static-1.5976",
      "quartz": "/quartz/static-1.6362",
      "react-dlb": "/react-dlb/static-1.65",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.3955",
      "StyleGuideUI": "/StyleGuideUI/static-3.479",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.4128",
      "usage-tracker": "/usage-tracker/static-1.6933",
      "usage-tracker-core": "/usage-tracker-core/static-1.6783",
      "usage-tracker-public": "/usage-tracker-public/static-1.6744",
      "viral-links-lib": "/viral-links-lib/static-1.6515",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5726",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4326",
      "conversations-prop-types": "/conversations-prop-types/static-1.6938",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5301",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19730",
      "cssUtils": "/cssUtils/static-1.652",
      "enviro": "/enviro/static-4.345",
      "flux-actions": "/flux-actions/static-1.291",
      "foundations-components": "/foundations-components/static-1.7090",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3768",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9233",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.16224",
      "react-utils": "/react-utils/static-2.4952",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7702",
      "signup-constants": "/signup-constants/static-1.17905",
      "styled-components": "/styled-components/static-2.64",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5347",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5537",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3036",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.140",
      "quartz-core": "/quartz-core/static-1.5581",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4385",
      "foundations-theming": "/foundations-theming/static-1.3924",
      "UIComponents": "/UIComponents/static-3.7965",
      "cv-backend-services": "/cv-backend-services/static-1.1397",
      "immutable-less": "/immutable-less/static-1.4106",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6852",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31803",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.1842",
      "icons": "/icons/static-2.599",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4204",
      "tanstack-virtual": "/tanstack-virtual/static-1.20",
      "ui-images": "/ui-images/static-2.1012",
      "HeadJS": "/HeadJS/static-2.655",
      "framer-motion": "/framer-motion/static-1.58",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2605",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.140",
      "i18n-data": "/i18n-data/static-1.212",
      "moment-timezone": "/moment-timezone/static-5.73",
      "jasmine": "/jasmine/static-4.3823",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7601",
      "HubStyle": "/HubStyle/static-2.11326",
      "sassPrefix": "/sassPrefix/static-1.146",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3359",
      "floating-ui": "/floating-ui/static-1.46",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1640",
      "hs-story-utils": "/hs-story-utils/static-1.8914",
      "react-virtualized": "/react-virtualized/static-2.87",
      "tanstack-table": "/tanstack-table/static-1.23",
      "trellis-assets": "/trellis-assets/static-1.799",
      "ui-fonts": "/ui-fonts/static-1.335",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3542",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5350",
      "bender-build-tools": "/bender-build-tools/static-1.2687",
      "dispatcher": "/dispatcher/static-1.126",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.734",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8934",
      "hubspotter-http": "/hubspotter-http/static-1.4246",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8932",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.428",
      "quartz-auth": "/quartz-auth/static-1.37",
      "quartz-head": "/quartz-head/static-1.27",
      "quartz-i18n": "/quartz-i18n/static-1.37",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2407",
      "foundations-theming-base": "/foundations-theming-base/static-1.2909",
      "stylex": "/stylex/static-1.22",
      "ts-schema": "/ts-schema/static-1.3720",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.2061",
      "content-assistance-lib": "/content-assistance-lib/static-1.7167",
      "crm-component-utils": "/crm-component-utils/static-1.37918",
      "crm-display-components": "/crm-display-components/static-1.23668",
      "crm-fe-perf": "/crm-fe-perf/static-1.22480",
      "crm-links": "/crm-links/static-1.5741",
      "crm-message-bus": "/crm-message-bus/static-1.41769",
      "crm-search-service-types": "/crm-search-service-types/static-1.808",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4818",
      "customer-data-communicator": "/customer-data-communicator/static-1.44303",
      "customer-data-email": "/customer-data-email/static-1.17218",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38102",
      "customer-data-objects": "/customer-data-objects/static-1.7204",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12543",
      "customer-data-properties": "/customer-data-properties/static-1.50101",
      "customer-data-rte": "/customer-data-rte/static-1.31909",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9315",
      "data-fetching-client": "/data-fetching-client/static-1.9233",
      "draft-plugins": "/draft-plugins/static-2.20848",
      "file-manager-components": "/file-manager-components/static-1.22213",
      "FileManagerCore": "/FileManagerCore/static-1.37712",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6464",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7514",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4378",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17012",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9551",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7596",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17248",
      "universal-associations-select": "/universal-associations-select/static-1.10529",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7725",
      "final-form": "/final-form/static-1.60",
      "graphql": "/graphql/static-1.72",
      "superstore": "/superstore/static-1.4295",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8324",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27330",
      "card-properties-lib": "/card-properties-lib/static-1.42924",
      "crm-actions": "/crm-actions/static-1.5759",
      "crm-cards-data": "/crm-cards-data/static-1.758",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42287",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8261",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7542",
      "customer-data-tracking": "/customer-data-tracking/static-1.6459",
      "usage-tracker-container": "/usage-tracker-container/static-1.6923",
      "framework-data-table": "/framework-data-table/static-2.10887",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7922",
      "calling-error-reporting": "/calling-error-reporting/static-1.30875",
      "calling-internal-common": "/calling-internal-common/static-1.30869",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6138",
      "crm_data": "/crm_data/static-4.90518",
      "crm_schema": "/crm_schema/static-3.90557",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23356",
      "customer-data-content": "/customer-data-content/static-1.26422",
      "draft-content-plugins": "/draft-content-plugins/static-1.27271",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23268",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.22968",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23528",
      "FileManagerLib": "/FileManagerLib/static-1.37853",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17004",
      "integration-settings-components": "/integration-settings-components/static-1.14057",
      "integrations-lib": "/integrations-lib/static-1.14721",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5176",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7385",
      "nav-meta": "/nav-meta/static-1.28328",
      "onboarding-scopes": "/onboarding-scopes/static-1.6044",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5352",
      "property-translator": "/property-translator/static-1.4925",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36507",
      "react-colorpicker": "/react-colorpicker/static-2.9772",
      "react-dnd-compat": "/react-dnd-compat/static-1.4224",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7756",
      "rich-text-lib": "/rich-text-lib/static-1.19012",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3436",
      "sequences-lib": "/sequences-lib/static-1.7356",
      "timezone-utils": "/timezone-utils/static-2.4740",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10589",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8499",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8507",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9821",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9650",
      "user-context": "/user-context/static-1.4677",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4349",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4253",
      "salesImages": "/salesImages/static-1.515",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20536",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12622",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4219",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3563",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6369",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3274",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3495",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.555",
      "onboarding-tours": "/onboarding-tours/static-1.15978",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12347",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.177",
      "ui-addon-teams": "/ui-addon-teams/static-1.20935",
      "calling-global-api": "/calling-global-api/static-1.62979",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64361",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56655",
      "commerce-products-lib": "/commerce-products-lib/static-1.8156",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3436",
      "external-options-client-types": "/external-options-client-types/static-1.3655",
      "google-libphonenumber": "/google-libphonenumber/static-1.27",
      "inbound-db-associations-writes-service-client": "/inbound-db-associations-writes-service-client/static-1.2762",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3754",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.137",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3284",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47283",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3496",
      "property-value-citations": "/property-value-citations/static-1.715",
      "smart-property-lib": "/smart-property-lib/static-1.5068",
      "tiered-pricing": "/tiered-pricing/static-1.499",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10558",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "immerable": "/immerable/static-1.3658",
      "video-components-external": "/video-components-external/static-1.9930",
      "video-data-lib": "/video-data-lib/static-1.33588",
      "audio-components": "/audio-components/static-1.5334",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35364",
      "ui-universal-auth": "/ui-universal-auth/static-1.8407",
      "video-components": "/video-components/static-1.11933",
      "video-embed": "/video-embed/static-1.34422",
      "batch-promise": "/batch-promise/static-1.1131",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3645",
      "persist-promise": "/persist-promise/static-1.3288",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24097",
      "knowledge-content-types": "/knowledge-content-types/static-1.8178",
      "payment-link-components": "/payment-link-components/static-1.22371",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9443",
      "call-summary": "/call-summary/static-1.37670",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9080",
      "feature-store-service-types": "/feature-store-service-types/static-1.4134",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4141",
      "merchandise-lib": "/merchandise-lib/static-1.248",
      "purchase-motions-components": "/purchase-motions-components/static-1.5090",
      "self-service-api": "/self-service-api/static-1.9776",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4125",
      "chatspot-client-types": "/chatspot-client-types/static-1.10247",
      "chatspot-core": "/chatspot-core/static-1.19540",
      "ContentUtils": "/ContentUtils/static-1.66998",
      "copilot-toolkit": "/copilot-toolkit/static-1.9918",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6091",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44785",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14186",
      "customer-data-associations": "/customer-data-associations/static-1.6827",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.580",
      "reporting-data": "/reporting-data/static-1.65639",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4349",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3283",
      "crm_universal": "/crm_universal/static-1.21376",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8483",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19915",
      "content-embed-lib": "/content-embed-lib/static-1.6942",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.10865",
      "remote-ui": "/remote-ui/static-1.55",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5156",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15889",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2586",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12136",
      "laboratory-lib": "/laboratory-lib/static-3.6694",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9973",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.44684",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15684",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7213",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4574",
      "magpie-lib": "/magpie-lib/static-1.5163",
      "navigation-messaging": "/navigation-messaging/static-1.6018",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17271",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16389",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7508",
      "growth-data-modal": "/growth-data-modal/static-1.4913",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2609",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.986",
      "navigation-components": "/navigation-components/static-1.16691",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4192",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.44",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7031",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10618",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34165",
      "products-iframe-lib": "/products-iframe-lib/static-1.6738",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9316",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5000",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9017",
      "fsm": "/fsm/static-1.3232",
      "policy-lib": "/policy-lib/static-1.6319",
      "react-tinymce": "/react-tinymce/static-1.54000",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53126",
      "tinymce-plugins": "/tinymce-plugins/static-1.56240",
      "tinymce-themes": "/tinymce-themes/static-1.55096",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10443",
      "content-media-compositions": "/content-media-compositions/static-2.14450",
      "idb-keyval": "/idb-keyval/static-1.34",
      "magpie-types": "/magpie-types/static-1.4623",
      "media-bridge-lib": "/media-bridge-lib/static-1.18218",
      "content-icons-ui": "/content-icons-ui/static-1.2067",
      "social-insights-client-types": "/social-insights-client-types/static-1.20823",
      "outpost": "/outpost/static-1.3829",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3182",
      "ui-addon-opt": "/ui-addon-opt/static-4.7996",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5363",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4691",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3194",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.6937",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18840",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.7536",
      "wootric-nps": "/wootric-nps/static-1.6463",
      "nav-client-types": "/nav-client-types/static-1.1824",
      "purchase-motions-api": "/purchase-motions-api/static-1.5092",
      "trials-service-types": "/trials-service-types/static-1.3542",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4257",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2558",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35922",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38298",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17858",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10426",
      "crm_components": "/crm_components/static-3.90518",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53335",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20395",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16440",
      "project-storage": "/project-storage/static-1.4228",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70420",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7433",
      "deal-intel-utils": "/deal-intel-utils/static-1.584",
      "reporting-client-types": "/reporting-client-types/static-1.2312",
      "react-flip-move": "/react-flip-move/static-1.60",
      "FireAlarmUi": "/FireAlarmUi/static-1.4139",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3808",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10406",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9037",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56605",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11460",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11388",
      "feedback-loader": "/feedback-loader/static-1.28379",
      "html-to-image": "/html-to-image/static-1.44",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6594",
      "property-management-iframe": "/property-management-iframe/static-1.11527",
      "reactflow": "/reactflow/static-1.51",
      "simple-data-table": "/simple-data-table/static-1.1546",
      "used-in-list-lib": "/used-in-list-lib/static-1.6449",
      "visual-association": "/visual-association/static-1.5380",
      "highcharts": "/highcharts/static-8.94",
      "reporting-visualizations": "/reporting-visualizations/static-1.57716",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3563",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2376",
      "ContentData": "/ContentData/static-1.67073",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.572",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1685",
      "reactive-lib": "/reactive-lib/static-1.281",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.118",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6318",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3612",
      "ui-tool-access": "/ui-tool-access/static-1.9684",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34390",
      "sales-views-client-types": "/sales-views-client-types/static-1.3843",
      "trellis-story-utils": "/trellis-story-utils/static-1.4083",
      "storybook-react": "/storybook-react/static-1.22",
      "hub-http-contrib": "/hub-http-contrib/static-1.2650",
      "interframe": "/interframe/static-3.4306",
      "tinymce-data": "/tinymce-data/static-1.39211",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4766",
      "codemirror": "/codemirror/static-5.85",
      "layout-dnd-components": "/layout-dnd-components/static-1.11639",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10614",
      "react-codemirror": "/react-codemirror/static-1.10206",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12943",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8718",
      "hls.js": "/hls.js/static-1.29",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.8650",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7002",
      "chirp-fetch": "/chirp-fetch/static-1.1486",
      "copilot-plugins": "/copilot-plugins/static-1.9891",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2823",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17355",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35875",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9301",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4619",
      "utility-belt": "/utility-belt/static-1.2046",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21240",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79138",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6289",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53351",
      "commerce-products-api": "/commerce-products-api/static-1.1553",
      "SafeStorage": "/SafeStorage/static-1.3899",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55409",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101095",
      "reporting-ui-components": "/reporting-ui-components/static-2.62913",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14192",
      "association-translator": "/association-translator/static-1.2705",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7796",
      "settings-ui-nav": "/settings-ui-nav/static-2.9738",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19532",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1401",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5359",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3855",
      "property-management-common": "/property-management-common/static-1.3814",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14441",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11455",
      "ExportDialog": "/ExportDialog/static-6.9982",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32788",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.8939",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.12914",
      "highlight.js": "/highlight.js/static-1.69",
      "reporting-action-components": "/reporting-action-components/static-1.40122",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9142",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5078",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13694",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4577",
      "qrcode-generator": "/qrcode-generator/static-1.59",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.50",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16863",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6780",
      "products-ui-components": "/products-ui-components/static-1.38675",
      "totals-ui-components": "/totals-ui-components/static-1.22388",
      "reporting-plugins": "/reporting-plugins/static-1.9609",
      "reporting-reports": "/reporting-reports/static-1.65319",
      "reporting-snowflake": "/reporting-snowflake/static-1.54259",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14440",
      "simple-menus-lib": "/simple-menus-lib/static-1.15957",
      "academy-common-lib": "/academy-common-lib/static-1.12374",
      "dashboard-lib": "/dashboard-lib/static-1.79755",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8237",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9967",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15736",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18329",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7579",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "commerce-permissions": "/commerce-permissions/static-1.299",
      "property-description-translator": "/property-description-translator/static-1.3372",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3401",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7635",
      "academy-service-client": "/academy-service-client/static-1.3245",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3496",
      "oauth-service-types": "/oauth-service-types/static-1.3808",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};